// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const klink: PokeData = {
  "id": 599,
  "name": "klink",
  "height": 3,
  "weight": 210,
  "base_experience": 60,
  "types": [
    PokeType.STEEL
  ],
  "api_moves": [
    "vice-grip",
    "bind",
    "hyper-beam",
    "thunder-shock",
    "screech",
    "zap-cannon",
    "lock-on",
    "charge",
    "metal-sound",
    "mirror-shot",
    "discharge",
    "charge-beam",
    "autotomize",
    "shift-gear",
    "gear-grind"
  ],
  "moves": [
    "thunder-shock",
    "zap-cannon",
    "metal-sound",
    "behemoth-bash",
    "gear-up",
    "metal-claw",
    "metal-burst",
    "meteor-mash",
    "magnet-bomb",
    "steel-beam",
    "metal-rush",
    "scrap-throw"
  ],
  "evolution_chain": {
    "id": 305,
    "item": null,
    "species": [
      {
        "name": "klink",
        "order": 600,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "klang",
        "order": 601,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": 599,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "klinklang",
        "order": 602,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": 600,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 49,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 52.5,
    "speed": 30,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 130,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
